import { render } from "./video-feed.vue?vue&type=template&id=85b28cda"
import script from "./video-feed.vue?vue&type=script&lang=js"
export * from "./video-feed.vue?vue&type=script&lang=js"

import exportComponent from "/Users/qmaura/PANOPTIC/lify-blends-recommender/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__